import { MessageIdentifier } from "@plex/culture-core";

import { INotification } from "infrastructure/notification";

export interface ITermTranslation {
  translationId: string;
  termId: string;
  localeName: string;
  industryDescription: string;
  translation: string;
  definition: string;
  source: MessageIdentifier;
  status: MessageIdentifier;
}

export interface ITerm {
  termId: string;
  term: string;
  definition: string;
}

export interface ITermWithTranslations {
  term: ITerm;
  translations: ITermTranslation[];
}

export interface ITermTranslationsState {
  translations?: ITermTranslation[];
  isLoading: boolean;
  notifications: INotification[];
}

export const getInitialTermTranslationsState = (): ITermTranslationsState => {
  return {
    translations: undefined,
    isLoading: false,
    notifications: []
  };
};
